// src/pages/ForgotPassword.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./ForgotPassword.css";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const navigate = useNavigate();

  const handleSend = async () => {
    if (!email) return;

    try {
      const res = await fetch("http://localhost:5000/api/forgot-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();

      if (!res.ok) {
        setErrorMsg(data.message || "Something went wrong.");
      } else {
        setMessage("Reset link has been sent to your email.");
        setEmail("");
      }
    } catch (err) {
      setErrorMsg("Server error. Try again later.");
    }
  };

  return (
    <div className="forgot-container">
      <div className="forgot-box">
        <h2>Forgot Password</h2>
        <p>Enter your registered email to receive a reset link.</p>
        <input
          type="email"
          placeholder="Email address"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
            setMessage("");
            setErrorMsg("");
          }}
        />
        {errorMsg && <p className="error">{errorMsg}</p>}
        {message && <p className="success">{message}</p>}

        <div className="forgot-buttons">
          <button
            onClick={handleSend}
            disabled={!email}
            className={email ? "active" : "inactive"}
          >
            Send Reset Link
          </button>
          <button className="cancel-btn" onClick={() => navigate("/login")}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
